import { render, staticRenderFns } from "./VerifyEmailModal.vue?vue&type=template&id=b9dc121a&scoped=true"
import script from "./VerifyEmailModal.vue?vue&type=script&lang=js"
export * from "./VerifyEmailModal.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmailModal.vue?vue&type=style&index=0&id=b9dc121a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9dc121a",
  null
  
)

export default component.exports